import { render } from "react-dom";
import { DEBUG } from "../../../../config";
import React, { FC, useState, memo, useEffect } from "../../../../lib/teact/teact";
import Loading from "../../../ui/Loading";
import { MessageReport, MessageReportImpl, TotalReportItemNhanChuyen } from "../../db/report/totalReport";
import { updateMienDaiCuoc } from "../../redux/basicReport";
import { updateWorkDate } from "../../redux/global";
import { ReportType } from "../../redux/TongHopSlice";
import { TongHopReport } from "../../restapi/tongHopReport";
import store from "../../store";
import LotSelect from "../../ui/lotSelect";
import MyDateInput from "../../ui/myDateInput";
import { GetMienCuPhapID, isCuPhapMn } from "../../utils/common";
import { tienFormat } from "../../utils/NumberUtils";
import MessageView from "./messageView";
import TotalReportByMessage from "./totalReportByMessage";

type OwnProps = {

}
type State = {
    dataNhan: MessageReport;
    dataChuyen: MessageReport;
    mienDaiCuocId: string;
    ngay: string;
    isLoading: boolean;
}
const TongHopNhanChuyen: FC<OwnProps> = ({
}) => {
    const [state, setState] = useState<State>({
        dataNhan: new MessageReportImpl(),
        dataChuyen: new MessageReportImpl(),
        mienDaiCuocId: '3',
        ngay: store.getState().global.workDate,
        isLoading: true
    })
    useEffect(() => {
        const mienCuPhapId = GetMienCuPhapID()
        if (mienCuPhapId == 1) {
            setState(prev => ({ ...prev, mienDaiCuocId: '1' }))
        }

    }, [])
    useEffect(() => {
        setState(prev => ({ ...prev, isLoading: true }))

        const params = {
            ngay: state.ngay, mienDaiCuocId: state.mienDaiCuocId,
            daiIds: [], loaiCuocIds: [], selectedReport: 'LaiLo' as ReportType, contactId: 0
        }
        const nhanVe: MessageReportImpl = new MessageReportImpl()
        const chuyenDi: MessageReportImpl = new MessageReportImpl()
        const data = TongHopReport.FetchLaiLo(params).then((data: any) => {
            const itemData = data.data as TotalReportItemNhanChuyen[]
            if (itemData == null) {


            } else {

                for (let dataItem of itemData) {
                    if (dataItem.nhanVe != null) {
                        nhanVe.addContactDataToReport(dataItem.nhanVe)
                        nhanVe.laiLo += dataItem.nhanVe.laiLo
                        nhanVe.quaCoHoi += dataItem.nhanVe.quaCoHoi
                        nhanVe.quaCo += dataItem.nhanVe.quaCo
                        nhanVe.thuongHoi += dataItem.nhanVe.thuongHoi
                        nhanVe.tienHoi += dataItem.nhanVe.tienHoi
                        nhanVe.laiLoToanBo += dataItem.nhanVe.laiLoToanBo
                        nhanVe.isTotalAllContact = true

                    }
                    if (dataItem.chuyenDi != null) {
                        chuyenDi.addContactDataToReport(dataItem.chuyenDi)
                        chuyenDi.laiLo += dataItem.chuyenDi.laiLo
                        chuyenDi.quaCoHoi += dataItem.chuyenDi.quaCoHoi
                        chuyenDi.quaCo += dataItem.chuyenDi.quaCo
                        chuyenDi.tienHoi += dataItem.chuyenDi.tienHoi
                        chuyenDi.thuongHoi += dataItem.chuyenDi.thuongHoi
                        chuyenDi.isTotalAllContact = true
                        chuyenDi.laiLoToanBo += dataItem.chuyenDi.laiLoToanBo
                    }
                }
                nhanVe.body = "Nhận về"
                chuyenDi.body = "Chuyển đi"
                nhanVe.sortByGroupName()
                chuyenDi.sortByGroupName()
                console.log('nhanVe', nhanVe)
                console.log('chuyenDi', chuyenDi)
            }
            setState(prev => ({
                ...prev,
                dataNhan: nhanVe,
                dataChuyen: chuyenDi,
                isLoading: false,
            }))
        })
        if (DEBUG) {
            console.log('data', data)
        }
    }, [state.ngay, state.mienDaiCuocId])
    function renderLaiLoToanBo() {
        const laiLoNhan = state.dataNhan.laiLoToanBo
        const laiLoChuyen = state.dataChuyen.laiLoToanBo
        const laiLo = laiLoNhan + laiLoChuyen;
        if (laiLo > 0) {
            return `Lãi: ${tienFormat(laiLo, 1)}`
        } else if (laiLo < 0) {
            return `Lỗ: ${tienFormat(laiLo, 1)}`
        }
    }
    return (
        <div className="form-main">
            <div className="form-header">
                <div className="form-header left-panel">
                    <LotSelect value={state.mienDaiCuocId} id="b"
                        onChange={(e) => {
                            setState(prev => ({ ...prev, mienDaiCuocId: e.target.value }))
                            store.dispatch(updateMienDaiCuoc({ mienDaiCuocId: e.target.value }))
                        }
                        }>
                        {isCuPhapMn() ? <>
                            <option value="3" selected={state.mienDaiCuocId == '3'}>Miền Nam</option>
                            <option value="2" selected={state.mienDaiCuocId == '2'}>Miền Trung</option>
                            <option value="1" selected={state.mienDaiCuocId == '1'}>Miền Bắc</option>
                            {/* <option value="0" selected={state.mienDaiCuocId == '0'}>Ba miền</option> */}
                        </> : <option value="1" selected={state.mienDaiCuocId == '1'}>Miền Bắc</option>
                        }
                    </LotSelect>
                    <input className=" date-input" type="date" value={state.ngay}
                        onChange={(e) => {
                            setState(prev => ({ ...prev, ngay: e.target.value }))
                            store.dispatch(updateWorkDate({ workDate: e.target.value }))
                        }}
                    />
                </div>
            </div>
            <div className="form-content">
                {state.isLoading ? <Loading /> :
                    <div className="form-content">

                        {state.dataNhan != null && state.dataNhan.children.length > 0 &&
                            <TotalReportByMessage data={state.dataNhan}
                                onChangeViewType={() => { }}
                                messageIndex={0}
                                onRemoveItem={() => { }}
                                onReloadItem={() => { }}
                                hideToolbar
                                key="nhan"
                                onChangeScreen={() => { }}
                                soTin={0}
                            />
                        }
                        {state.dataChuyen != null && state.dataChuyen.children.length > 0 &&
                            <TotalReportByMessage data={state.dataChuyen}
                                onChangeViewType={() => { }}
                                messageIndex={0}
                                onRemoveItem={() => { }}
                                onReloadItem={() => { }}
                                hideToolbar
                                key="chuyen"
                                onChangeScreen={() => { }}
                                soTin={0}
                            />
                        }
                        {
                            renderLaiLoToanBo()
                        }
                    </div>
                }
            </div>
        </div>
    )
}
export default memo(TongHopNhanChuyen)